/* ============================================================
   BOOK SELECTORS
============================================================ */

export const selectBookState = (state) =>
  state.admin?.book || {};

export const selectBooks = (state) =>
  selectBookState(state).books || [];

export const selectBookChapters = (state) =>
  selectBookState(state).chapters || [];

export const selectBookLoading = (state) =>
  selectBookState(state).loading || false;

export const selectBookError = (state) =>
  selectBookState(state).error || null;